import { sendTrigger, TriggerType } from 'src/services/trigger.service';

export const useTrigger = () => {
  return {
    sendTrigger,
    triggerTypes: TriggerType,
  };
};
